export default {
  platform: [],
  note: [],
  pov: [],
  demographic: { age_range: [], ethnicity: [], gender: [] },
  category: [],
  product: { radio: true, value: null },
  competitor_brands: { radio: true, value: null },
};
